<template>
    <div class="screen">
        <div class="eventRequests">
            <div class="feedback-card" style="background-color: #f86c6b"
                 v-for="[key, val] of feedback.entries()" v-bind:key="key">
                <div class="feedback-row">
                    <div>Email</div>
                    {{key}}
                </div>
                <div>Messages</div>
                <div class="message">
                    <div v-for="(message,index)  in val" v-bind:key="index">
                        <div style="border-bottom: 1px solid #f19190">
                            {{message.message}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import UsersService from '@/common/services/users.service'
    import CommonUtils from "../common/services/CommonUtils";
    import {mapMutations, mapState} from "vuex";
    import mutations from "@/store/mutation_types";

    export default {
        name: "Feedback",
        data() {
            return {
                search: '',
                all_users: 0,
                companies: 0,
                users_length: 0,
                parking_zones: 0,
                bus_lines: 0,
                travel_offers: 0,
                loading: false
            }
        },
        computed: {
            ...mapState({
                feedback: state => state.feedback
            }),
        },
        methods: {
            ...mapMutations(['SET_FEEDBACK', 'SET_USER_EMAIL']),
            onChangeText() {
                console.log('changed')
            }
        },
        beforeMount() {
            this.loading = true;
            let user = CommonUtils.getCookie('user_email');
            this[mutations.SET_USER_EMAIL](user);
            UsersService.getUserFeedback().then(res => {
                console.log(res)
                let map = new Map;
                let feedback = res.data;
                feedback.forEach(el => {
                    let userFeeback = map.get(el.email)
                    console.log("userFeeback", userFeeback)
                    if (userFeeback) {
                        userFeeback.push(el)
                        map.set(el.email, userFeeback)
                    } else {
                        map.set(el.email, [el])
                    }
                })
                this[mutations.SET_FEEDBACK](map);
            }).catch(err => {
                this.$notify.error({
                    title: `Failed to get feedbacks`,
                    message: err.response.data.message
                });
            }).finally(() => {
                this.loading = false
            })
        }
    }
</script>

<style lang="scss" scoped>
    .screen {
        grid-template-areas: "eventContainer";
        width: 100%;
        height: 100%;
        /*height: 100vh;*/
        /*grid-gap: 10px;*/
        /*background-color: #f6f6f6;*/
        overflow: scroll;
        @media screen and(min-width: 768px){
           display: flex;
            justify-content: center;
        }
    }

    .eventRequests {
        grid-area: eventContainer;
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 20px;
        margin: 20px;

        @media screen and (max-width: 768px) {
            display: grid;
            grid-template-columns: 1fr;
        }

        @media screen and(min-width: 768px){
            min-width: 60vw;
        }
    }

    .feedback-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between
    }

    .feedback-card {
        /*text-align: left;*/
        border: 1px solid whitesmoke;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        border-radius: 5px;
        cursor: pointer;
        -webkit-box-shadow: 0 0 5px #c7c1c1;
        display: grid;
        width: 100%;
        color: white;
        flex-direction: column;
        font-family: 'Lato', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        padding: 15px;
        grid-template-rows: 1fr 1fr;

        @media screen and (max-width: 768px) {
            min-height: 80px;
        }
    }

    .message {
        background-color: white;
        width: 100%;
        display: flex;
        flex-direction: column;
        color: #f86c6b;
        padding: 5px;
        border-radius: 5px;
        text-align: left;
    }

</style>
